import {
  OneSiteIcon,
  OneCarIcon,
  SecurityIcon,
  PersonIcon,
  GroupIcon,
  StopwatchIcon,
  LoginIcon,
  LogoutIcon,
} from 'assets/icons';
import { ChannelTypes } from 'ducks/chat/types';

export const DEFAULT_CHANNEL_TYPE = ChannelTypes.SITE;

export const MAX_FILE_SIZE = 8 * 1024 * 1024; // 8 MB — matches server @MultipartConfig maxFileSize

export const SCROLL_THRESHOLD = 300;

export const MARK_AS_READ_DELAY_MS = 1500;

export const SENDER_COLORS = [
  '#F78F1E', '#42BD5D', '#0080FF', '#EC544A',
  '#10B8C9', '#C4956A', '#00B400', '#7B61FF',
];

export const CHANNEL_ICONS = {
  [ChannelTypes.SITE]: OneSiteIcon,
  [ChannelTypes.MOBILE_PATROL]: OneCarIcon,
  [ChannelTypes.BRANCH]: SecurityIcon,
};

export const VIEW_TYPE_BUTTONS = [
  { key: ChannelTypes.BRANCH, icon: CHANNEL_ICONS[ChannelTypes.BRANCH] },
  { key: ChannelTypes.SITE, icon: CHANNEL_ICONS[ChannelTypes.SITE] },
  { key: ChannelTypes.MOBILE_PATROL, icon: CHANNEL_ICONS[ChannelTypes.MOBILE_PATROL] },
];

export const isBranch = (channel) => channel?.type === ChannelTypes.BRANCH;

export const getEmployeeIcon = (channel) => {
  if (isBranch(channel)) return SecurityIcon;
  if (channel?.employeeCount === 1) return PersonIcon;
  return GroupIcon;
};

export const getEmployeeLabel = (channel, formatMessage) => {
  if (isBranch(channel)) return null;
  if (channel?.employeeCount === 1 && channel?.employeeName) {
    return `${channel.employeeName}, ${channel.employeePosition}`;
  }
  if (channel?.employeeCount > 0) {
    return `${channel.employeeCount} ${formatMessage({ id: 'active_employees_count' })}`;
  }
  return formatMessage({ id: 'no_active_employees' });
};

export const ACTIVITY_DISPLAY = {
  start: { icon: StopwatchIcon, labelKey: 'shift_started' },
  end: { icon: StopwatchIcon, labelKey: 'shift_ended' },
  visit_started: { icon: LoginIcon, labelKey: 'visit_started' },
  visit_ended: { icon: LogoutIcon, labelKey: 'visit_ended' },
};

export const getLastMessagePreview = (channel, formatMessage, currentUserID) => {
  const m = channel?.lastMessage;
  if (!m) return null;
  const isOwn = currentUserID != null && m.userCreated === currentUserID;
  const senderName = isOwn ? formatMessage({ id: 'you' }) : (m.userCreatedName || null);
  if (m.status === 'D') {
    return { sender: senderName, text: formatMessage({ id: 'message_deleted' }), hasPhoto: false, italic: true };
  }
  if (m.type === 'activity') {
    const display = ACTIVITY_DISPLAY[m.activityType];
    return display
      ? {
          sender: senderName,
          text: formatMessage({ id: display.labelKey }),
          hasPhoto: false,
          activityIcon: display.icon,
          italic: true,
        }
      : null;
  }
  const hasPhoto = !!m.mediaAssetID;
  const text = m.content || (hasPhoto ? formatMessage({ id: 'last_message_photo' }) : null);
  if (!text) return null;
  return { sender: senderName, text, hasPhoto, italic: false };
};
